// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects'

import {
  getIdeas as getIdeasAPI,
  getIntro as getIntroAPI,
  getOutlines as getOutlinesAPI,
  writeArticle as writeArticleAPI,
  expandText as expandTextAPI,
  instantWriter as instantWriterAPI,
  writeParagraph as writeParagraphAPI,
  generateImage as generateImageAPI
} from '../../helpers/'

import { writesonicApiResponseError, writesonicApiResponseSuccess } from './actions'
import { WritesonicActionTypes } from './constants'

function * getIdeas ({ payload: params }) {
  try {
    const response = yield call(getIdeasAPI, { ...params })
    const ideas = response.data.data
    yield put(writesonicApiResponseSuccess(WritesonicActionTypes.GET_IDEAS, ideas))
  } catch (error) {
    yield put(writesonicApiResponseError(WritesonicActionTypes.GET_IDEAS, error))
  }
}

function * getIntro ({ payload: params }) {
  try {
    const response = yield call(getIntroAPI, { ...params })
    const intro = response.data.data
    yield put(writesonicApiResponseSuccess(WritesonicActionTypes.GET_INTRO, intro))
  } catch (error) {
    yield put(writesonicApiResponseError(WritesonicActionTypes.GET_INTRO, error))
  }
}

function * getOutlines ({ payload: params }) {
  try {
    const response = yield call(getOutlinesAPI, { ...params })
    const outlines = response.data.data
    yield put(writesonicApiResponseSuccess(WritesonicActionTypes.GET_OUTLINES, outlines))
  } catch (error) {
    yield put(writesonicApiResponseError(WritesonicActionTypes.GET_OUTLINES, error))
  }
}

function * writeArticle ({ payload: params }) {
  try {
    const response = yield call(writeArticleAPI, { ...params })
    const article = response.data.data
    yield put(writesonicApiResponseSuccess(WritesonicActionTypes.WRITE_ARTICLE, article))
  } catch (error) {
    yield put(writesonicApiResponseError(WritesonicActionTypes.WRITE_ARTICLE, error))
  }
}

function * expandText ({ payload: params }) {
  try {
    const response = yield call(expandTextAPI, { ...params })
    const expandedText = response.data.data
    yield put(writesonicApiResponseSuccess(WritesonicActionTypes.EXPAND_TEXT, expandedText))
  } catch (error) {
    yield put(writesonicApiResponseError(WritesonicActionTypes.EXPAND_TEXT, error))
  }
}

function * instantWriter ({ payload: params }) {
  try {
    const response = yield call(instantWriterAPI, { ...params })
    const result = response.data.data
    yield put(writesonicApiResponseSuccess(WritesonicActionTypes.INSTANT_WRITER, result))
  } catch (error) {
    yield put(writesonicApiResponseError(WritesonicActionTypes.INSTANT_WRITER, error))
  }
}

function * writeParagraph ({ payload: params }) {
  try {
    const response = yield call(writeParagraphAPI, { ...params })
    const paragraph = response.data.data
    yield put(writesonicApiResponseSuccess(WritesonicActionTypes.WRITE_PARAGRAPH, paragraph))
  } catch (error) {
    yield put(writesonicApiResponseError(WritesonicActionTypes.WRITE_PARAGRAPH, error))
  }
}

function * generateImage ({ payload: params }) {
  try {
    const response = yield call(generateImageAPI, { ...params })
    const image = response.data.data
    yield put(writesonicApiResponseSuccess(WritesonicActionTypes.GENERATE_IMAGE, image))
  } catch (error) {
    yield put(writesonicApiResponseError(WritesonicActionTypes.GENERATE_IMAGE, error))
  }
}

export function * watchGetIntro () {
  yield takeEvery(WritesonicActionTypes.GET_INTRO, getIntro)
}

export function * watchGetOutlines () {
  yield takeEvery(WritesonicActionTypes.GET_OUTLINES, getOutlines)
}

export function * watchGetIdeas () {
  yield takeEvery(WritesonicActionTypes.GET_IDEAS, getIdeas)
}

export function * watchWriteArticle () {
  yield takeEvery(WritesonicActionTypes.WRITE_ARTICLE, writeArticle)
}

export function * watchExpandText () {
  yield takeEvery(WritesonicActionTypes.EXPAND_TEXT, expandText)
}

export function * watchInstantWriter () {
  yield takeEvery(WritesonicActionTypes.INSTANT_WRITER, instantWriter)
}

export function * watchWriteParagraph () {
  yield takeEvery(WritesonicActionTypes.WRITE_PARAGRAPH, writeParagraph)
}

export function * watchGenerateImage () {
  yield takeEvery(WritesonicActionTypes.GENERATE_IMAGE, generateImage)
}

function * writesonicSaga () {
  yield all([
    fork(watchGetIdeas),
    fork(watchGetIntro),
    fork(watchGetOutlines),
    fork(watchWriteArticle),
    fork(watchExpandText),
    fork(watchInstantWriter),
    fork(watchWriteParagraph),
    fork(watchGenerateImage)
  ])
}

export default writesonicSaga
